module.exports = __webpack_public_path__ + "static/media/6.15.23513090.png";